export const API_SUCCESS_MESSAGE = "保存しました。";
export const API_UNKNOWN_ERROR_MESSAGE = "不明なエラー";
export const PREVENT_URL = "不適切なURLです";
export const DEFAULT_TIMER = 500;
export const MAX_INTEGER = 2147483646;
export const PASSWORD_CHANGE_SUCCESS_MESSAGE = "パスワードが再設定されました。";
export const CACHED_TIME = 10000;
export const MAXIMUM_NUMBER_VALIDATION = 9999999999999;
export const MAX_SPECIFIC_SKILL_TRANSITION_MONTH_PERIOD = 0;
export const MAX_SPECIFIC_SKILL_TRANSITION_YEAR_PERIOD = 5;
export const ZIP_CODE_DEBOUNCE_DELAY = 100;
